<form (ngSubmit)="submit()" [class]="'pr-form ' + clazz">
  <div class="pr-form-title">
    <div class="pr-form-title-primary">{{ title }}</div>
    <div class="pr-form-title-secondary">
      <ng-content select="[top-right-action]"></ng-content>
    </div>
  </div>
  <div [ngClass]="'pr-form-content ' + (formWithTabs ? 'tabs' : '')">
    <ng-content></ng-content>
  </div>
  <div class="pr-form-submit flex-row">
    <pr-button
      clazz="btn-cancel neutral"
      size="lg"
      type="button"
      label="annuler"
      (onClick)="cancel()"
    ></pr-button>
    @if (!noSubmitBtn) {
      <pr-button
        size="lg"
        type="submit"
        display="neutral"
        [label]="!isLastTab && formWithTabs ? 'suivant' : submitLabel"
      ></pr-button>
    }
  </div>

  <ng-content select="pr-subform"></ng-content>
</form>
